<template>
  <v-autocomplete
    class="organization-sub-perimeter-select"
    ref="input"
    :label="label"
    v-model="data"
    v-on="$listeners"
    :search-input.sync="search"
    :items="items"
    :loading="loading"
    item-value="id"
    item-text="name"
    :readonly="readonly"
    :disabled="disabled || (requirePerimeter && !perimeterId)"
    :clearable="clearable"
    :rules="computedRules"
    hide-details
    hide-no-data
    :solo="solo"
    :multiple="multiple"
    :append-icon="appendIcon"
    :placeholder="placeholder"
    :persistent-placeholder="!!placeholder"
    autocomplete="nope"
  />
</template>

<script>
import OrganizationPerimeterRepository from "@repository/OrganizationPerimeterRepository";

export default {
  name: 'OrganizationSubPerimeterSelect',
  model: { prop: 'value' },
  props: {
    // v-model: subPerimeterId (string|null)
    value: { type: [String, null], default: null },
    perimeterId: { type: String, default: null },
    rules: { type: Array, default: () => [] },
    required: { type: Boolean, default: false },
    requirePerimeter: { type: Boolean, default: false },
    disabled: Boolean,
    readonly: Boolean,
    solo: Boolean,
    appendIcon: String,
    placeholder: String,
    multiple: Boolean,
    clearable: { type: Boolean, default: false },
    label: String,
  },
  data() {
    return {
      data: this.value,
      items: [],
      search: null,
      loading: false,
    }
  },
  computed: {
    computedRules() {
      const base = [...this.rules]
      if (this.required) {
        base.unshift(v => !!v || this.$t('required'))
      }
      return base
    }
  },
  watch: {
    value(val) { this.data = val },
    data(val) { this.$emit('input', val) },
    perimeterId(val) {
      if(val) {
        this.data = null;
      }
      this.loadItems()
    },
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    localizedName(nameArr) {
      if (this.localizedString) {
        return this.localizedString(nameArr) || nameArr
      }
      return Array.isArray(nameArr) ? (nameArr[0]?.value || '') : (nameArr || '')
    },
    loadItems() {
      if (this.requirePerimeter && !this.perimeterId) {
        this.items = []
        this.data = null
        return
      }
      this.loading = true
      const filters = this.perimeterId ? { perimeterIds: [this.perimeterId] } : {}
      OrganizationPerimeterRepository.searchSubPerimeters('', 0, 1000, 'name', 'asc', filters)
        .then(res => {
          this.items = (res.items || []).map(sp => ({ id: sp.id, name: this.localizedName(sp.name) }))
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$dialog?.notify?.error(this.$t(err?.response?.data?.message || err?.message))
        })
    },

    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss">
.organization-sub-perimeter-select {}
</style>
